module.exports = __webpack_public_path__ + "img/5-4.876ce4c0.svg";